import React from "react";
import { DropTarget } from "react-dnd";

const style = {
  display: "contents",
  alignItems: "center",
  justifyContent: "left",
  padding: "1rem",
  textAlign: "left",
  fontSize: "1rem",
  lineHeight: "50px",
  float: "left",
};

export const Dustbin = ({
  accepts,
  name,
  text,
  lastText,
  isOver,
  canDrop,
  connectDropTarget,
  lastDroppedItem,
  key,
}) => {
  function wrapTextNode(textNode) {
    var spanNode = document.createElement("input");

    spanNode.setAttribute("class", "inputHeigth");
    spanNode.setAttribute("readonly", "readonly");
    spanNode.style.backgroundColor = "#effaff";
    spanNode.style.borderRadius = ".5rem";
    spanNode.style.border = "none";
    spanNode.style.height = "3.6rem";
    spanNode.style.boxShadow = `
        inset 0 4px 3px rgb(0 0 0 / 0.07),
        inset 0 2px 2px rgb(0 0 0 / 0.06)
    `;
    var newTextNode = document.createTextNode(textNode.textContent);
    spanNode.appendChild(newTextNode);
    textNode.parentNode.replaceChild(spanNode, textNode);
  }

  [].forEach.call(document.querySelectorAll("#input"), function (el) {
    var textNode = el.childNodes[0];

    wrapTextNode(textNode);
  });

  return connectDropTarget(
    <span style={{ ...style, whiteSpace: "pre-line" }}>
      &nbsp;{text.replace(/ - /g, "\n")}&nbsp;
      {lastDroppedItem ? (
        <i
          style={{
            color: "#021167",
            border: "2px solid #66BC77",
            padding: "1rem 3rem",
            borderRadius: ".5rem",
            fontWeight: "bold",
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
          }}
        >
          {accepts}
        </i>
      ) : (
        <span id="input"> </span>
      )}
    </span>
  );
};
export default DropTarget(
  (props) => props.accepts,
  {
    drop(props, monitor) {
      props.onDrop(monitor.getItem());
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  })
)(Dustbin);
